import { Box, Paper, Typography, useTheme } from "@mui/material";
import React from "react";

const Forbidden = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 10,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
          background: theme.color.PaperbgColor,
          width: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center   ",
        }}
      >
        <Box>
          <Typography variant="h3" gutterBottom>
            403 - Forbidden
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Sorry, you do not have permission to access this page.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Forbidden;
